export const createAlertAsyncModule = {
  importFn: () => import(/* webpackChunkName: "create-alert" */ './DialogContent'),
  cacheKey: 'create-alert',
}
